// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'inventory-category.page.title': 'Categories',
    'inventory-category.page.search_results': 'Search Results',
    'inventory-category.page.create.title': 'Create Category',
    'inventory-category.page.search.title': 'Find Categories',
    'inventory-category.page.edit.title': 'Edit Category',
    'inventory-category.page.view.title': 'View Category',
    'inventory-category.page.all': 'All',

    'inventory-category.button.cancel': 'Cancel',
    'inventory-category.button.select': 'Select',
    'inventory-category.button.find': 'Find Categories',
    'inventory-category.button.search': 'Apply',
    'inventory-category.button.create': 'Create Category',
    'inventory-category.button.new': 'New Category',
    'inventory-category.button.save': 'Save Changes',
    'inventory-category.button.delete': 'Permanently Delete',
    'inventory-category.button.edit': 'Edit',
    'inventory-category.button.restore': 'Restore',
    'inventory-category.button.reset': 'Reset',

    'inventory-category.placeholder.search': 'Search categories',

    'inventory-category.link.create_first_inventory_category': 'Click here to create your first category',
    'inventory-category.link.inventory_categories': ' Return to Categories',
    'inventory-category.link.retry': 'Click here to retry',

    'inventory-category.checkbox.all': 'Check All',
    'inventory-category.checkbox.actions_label': 'with selected',

    'inventory-category.label.inventory_category_name': 'Category Name',

    'inventory-category.sort.field_label': 'Field',
    'inventory-category.sort.direction_label': 'Direction',
    'inventory-category.sort.direction_ascending': 'Ascending',
    'inventory-category.sort.direction_descending': 'Descending',

    'inventory-category.modal.title.inventory_category_delete_permanently': 'Delete Category',
    'inventory-category.modal.title.inventory_category_restore': 'Restore Category',

    'inventory-category.modal.message.inventory_category_delete_permanently':
        'Are you sure that you want to permanently delete this category? This action cannot be undone. | Are you sure that you want to permanently delete these categories? This action cannot be undone.',
    'inventory-category.modal.message.inventory_category_restore': 'Are you sure that you want to restore this category? | Are you sure that you want to restore these categories?',

    'inventory-category.success.message.inventory_category_created': 'Your category has been created',
    'inventory-category.success.message.inventory_category_updated': 'Your category has been updated',
    'inventory-category.success.message.inventory_category_restored': 'Your category has been restored | All selected categories were restored',
    'inventory-category.success.message.inventory_category_deleted': 'Your category has been permanently deleted | All selected categories were permanently deleted',

    'inventory-category.error.message.inventory_category_deleted': 'This category was already permanently deleted | These categories were already permanently deleted',
    'inventory-category.error.message.inventory_category_restored': 'This category was already restored | These categories were already restored',
    'inventory-category.error.message.error_loading_page': 'Sorry, there was an error loading category.| Sorry, there was an error loading categories.',
};
